import {Component} from '@angular/core';

@Component({
    selector: 'app-cant-access-path',
    templateUrl: './cant-access-path.component.html',
    styleUrls: ['./cant-access-path.component.scss'],
    standalone: false
})
export class CantAccessPathComponent {

}
